import { ElementMatcher } from './common/ElementMatcher';
export class AnyLink {
    constructor(win = window, doc = win.document) {
        this.win = win;
        this.doc = doc;
    }
    activate() {
        this.doc.addEventListener('click', (event) => {
            if (!(event.target instanceof HTMLElement))
                return;
            this.handleClick(event.target);
        });
    }
    handleClick(target) {
        const element = ElementMatcher.findParentOrSelf(target, '[data-link]');
        if (!element)
            return;
        const href = element.dataset.link;
        if (!href)
            return;
        this.win.location.replace(href);
    }
}
